export const GET_CUSTOMER = "GET_CUSTOMER";
export const UPDATE_INFO_CUSTOMER = "UPDATE_INFO_CUSTOMER";
export const UPLOAD_AVATAR = "UPLOAD_AVATAR";
export const CUSTOMER_LOGOUT = "USER_LOGOUT";
export const CUSTOMER_ADDRESSES = "CUSTOMER_ADDRESSES";
